import { useContext, useEffect, useMemo, useState } from 'react';
import ReactModal from 'react-modal';
import { IoIosClose } from 'react-icons/io';

import Button from 'components/ui/button';
import { useModal } from 'context/ModalContext';
import Box from 'components/ui/box';
import { actionLog } from 'services/actionlog.service';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  playerInfo: any;
  data?: any;
}

export default function ModalStopQuiz(props: Props) {
  ReactModal.setAppElement('#modal');

  const modalID = 'validation-stop-quiz';

  const { openModal, modalData, closeModal } = useModal();
  const { callback, id, playerInfo, data } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  async function send() {
    if (!playerInfo?._id) return;

    setLoading(true);

    await actionLog(playerInfo.chave, 'answer_quiz', {
      taskId: data._id,
      answered: false,
    });

    callback({ id: 'stop_quiz' });
    closeModal();
    setLoading(false);
  }

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Avaliação"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 bg-black bg-opacity-60 flex flex-col items-center w-screen h-screen p-6 pt-[10vh] overflow-y-auto"
        contentElement={() => (
          <Box className={`w-[90%] lg:w-auto lg:max-w-[600px]`}>
            <Button
              color="primary"
              className="absolute -right-5 -top-5 rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
              onClick={() => (!loading ? closeModal() : null)}
            >
              <IoIosClose color="white" size={40} />
            </Button>

            <div className="w-full lg:w-[536px] flex flex-col items-center justify-center space-y-8">
              <h4 className="block text-center text-yellow text-lg font-semibold leading-none">Matriz de orientação</h4>
              <p className="text-alice-blue text-base font-thin block">
                Ao negar a possibilidade de apreciar a realização pela orientação da matriz, essa ação não poderá ser desfeita.
                Deseja confirmar essa ação?
              </p>
              <button
                className={`text-white bg-slate-blue text-sm inline-flex items-center justify-center font-semibold uppercase rounded py-3 px-4 leading-none`}
                onClick={() => {
                  send();
                }}
              >
                CONFIRMAR
              </button>
            </div>
          </Box>
        )}
      />
    </>
  );
}
